import ActivityPage from './ActivityPage.container'
export default ActivityPage
